import React, { Suspense } from "react";
import { Route } from "react-router-dom";

const ShareholdersEnterLeave = React.lazy(() => import("./index"));
const ShareholderEnterLeaveTable = React.lazy(() => import("./shareholderEnterLeaveTable"));
const ShareholderEnterLeave = React.lazy(() => import("./shareholderEnterLeave"));
const ShareholderEnterLeaveDetail = React.lazy(() => import("./shareholderEnterLeaveDetail"));

export const useShareholderEnterLeaveRoutes = () => {
  return (
    <Route
      path="shareholdersEnterLeave"
      element={
        <Suspense fallback={<div>منتظر باشید...</div>}>
          <ShareholdersEnterLeave />
        </Suspense>
      }>
      <Route
        index
        element={
          <Suspense fallback={<div>منتظر باشید...</div>}>
            <ShareholderEnterLeaveTable />
          </Suspense>
        }
      />
      <Route
        path=":recordId"
        element={
          <Suspense fallback={<div>منتظر باشید...</div>}>
            <ShareholderEnterLeave />
          </Suspense>
        }>
        <Route
          index
          element={
            <Suspense fallback={<div>منتظر باشید...</div>}>
              <ShareholderEnterLeaveDetail />
            </Suspense>
          }
        />
      </Route>
    </Route>
  );
};
